import { render, staticRenderFns } from "./LiveFeed.vue?vue&type=template&id=30081b7a"
import script from "./LiveFeed.vue?vue&type=script&lang=js"
export * from "./LiveFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports